<script>
export default {
    name: "customerService",
    data() {
        return {
            isShow: false,
            isFirstShow: false,
            list: [],
            content: '',
            emoji: ['😀','😁','😂','🤣','😃','😄','😅','😆','😉','😊','😋','😎','😍','😘','🥰','😗','😙','😚','🙂','🤗','🤩','🤔','🤨','😐','😑','😶','🙄','😏','😣','😥','😮','🤐','😯','😪','😫','🥱','😴','😌','😛','😜','😝','🤤','😒','😓','😔','😕','🙃','🤑','😲','🙁','😖','😞','😟','😤','😢','😭','😦','😧','😨','😩','🤯','😬','😰','😱','🥵','🥶','😳','🤪','😵','🥴','😠','😡','🤬','😷','🤒','🤕','🤢','🤮','🤧','😇','🥳','🥺','🤠','🤡','🤥','🤫','🤭','🧐','🤓','😈','👿','👹','👺','💀','👻','👽','👾','🤖','💩','😺','😸','😹','😻','😼','😽','🙀','😿','😾','🐱‍👤','🐱‍🏍','🐱‍💻','🐱‍🐉','🐱‍👓','🐱‍🚀','🙈','🙉','🙊','🐵','🐶','🐺','🐱','🦁','🐯','🦒','🦊','🦝','🐮','🐷','🐗','🐭','🐹','🐰','🐻','🐨','🐼','🐸','🦓','🐴','🦄','🐔','🐲','🐽','🐾','🐒','🦍','🦧','🦮','🐕‍🦺','🐩','🐕','🐈','🐅','🐆','🐎','🦌','🦏','🦛','🐂','🐃','🐄','🐖','🐏','🐑','🐐','🐪','🐫','🦙','🦘','🦥','🦨','🦡','🐘','🐁','🐀','🦔','🐇','🦎','🐊','🐢','🐍','🐉','🦕','🦖','🦦','🦈','🐬','🐳','🐋','🐟','🐠','🐡','🦐','🦑','🐙','🦞','🦀','🐚','🦆','🐓','🦃','🦅','🦢','🦜','🦩','🦚','🦉','🐦','🐧','🐥','🐤','🐣','🦇','🦋','🐌','🐛','🦟','🦗','🐜','🐝','🐞','🦂','🦠','🧞‍♀️','🧞‍♂️','👤','👥','👀','🦴','🦷','👅','👄','🧠','🦾','🦿','👣','🤺'],
            isShowEmoji: false,
            ws: null,
            user_id: '',
            user_name: '',
            imageMaxWdith: 200,
            hasNewMes: localStorage.getItem('hasNewMes') == 1,
        };
    },
    computed: {
        toReg(){
            return text => {
                // link
                let reg = new RegExp(/(https?:\/\/)?(([0-9a-z.]+\.[a-z]+)|(([0-9]{1,3}\.){3}[0-9]{1,3}))(:[0-9]+)?(\/[0-9a-z%/.\-_]*)?(\?[0-9a-z=&%_\-]*)?(\#[0-9a-z=&%_\-]*)?/ig);
                text = text.replace(reg, ($0, $1) => {
                    return '<a target="_blank" href="' 
                    + ($1 ? '' : 'http://') //如果没有匹配到协议，自动添加http协议
                    + $0 + '">' + $0 + '</a>';
                })

                return text;
            }
        },
    },
    components: {
        
    },
    mounted() {
        window.addEventListener('click', this.hideEmoji);
        this.getData();
    },
    destroyed() {
        window.removeEventListener('click', this.hideEmoji);
    },
    watch: {
        isShow(val){
            if(val){
                // 第一次打开
                if(!this.isFirstShow){
                    this.isFirstShow = true;
                    this.wsInit();
                }
                this.list = this.list.map( v => {
                    v.isShow = true;
                    return v;
                })
                document.body.style.overflow = 'hidden';
                this.hasNewMes = false;
                localStorage.setItem('hasNewMes', 0);
            }else{
                document.body.style.overflow = 'visible';
            }
        },
        list(val){
            this.$nextTick(()=> {
                if(val.length > 0){
                    this.$refs.messageWrap.scrollTo({
                        behavior: "smooth",
                        top: this.$refs.message.offsetHeight
                    })
                }
            })
        },
    },
    methods: {
        getData(){
            this.$store.dispatch('getMessage').then((result) => {
                // console.log(result)
                this.list = result.list.map( v => {
                    if(v.type == 2){
                        if(v.width > this.imageMaxWdith){
                            let scale = this.imageMaxWdith / v.width;
                            v._width = this.imageMaxWdith;
                            v._height = v.height * scale;
                        }else{
                            v._width = v.width;
                            v._height = v.height;
                        }
                        v.isLoading = true;
                        v.isError = false;
                        v.isGet = true;
                        v.isShow = false;
                    }
                    return v;
                });
                if(this.list.length > 0){
                    let oldLastTime = localStorage.getItem('messageLastTime');
                    let newLastTime = this.list[this.list.length - 1].created_at;
                    if(newLastTime != oldLastTime){
                        this.hasNewMessage(newLastTime);
                    }
                }
                this.user_id = result.user_id;
                this.user_name = result.user_name;
            });
        },
        hasNewMessage(time){
            if(!this.isShow){
                this.hasNewMes = true;
                localStorage.setItem('hasNewMes', 1);
            }
            localStorage.setItem('messageLastTime', time);
        },
        wsInit(){
            let self = this;
            this.ws = new WebSocket("wss://www.440me.com/wss");
            this.ws.onopen = function() {
                console.log("连接成功");
            };
            this.ws.onmessage = function(e) {
                // console.log("收到服务端的消息：" + e.data);
                var data = JSON.parse(e.data);
                // console.log(data)
                switch (data.type) {
                    case "init":
                        var bild = {
                            mode: "bind",
                            from_userid: self.user_id,
                            to_userid: self.user_id,
                        };
                        self.ws.send(JSON.stringify(bild));
                        return;
                    case 1:
                        // text
                        if (data.code == 100) {
                            self.hasNewMessage(data.data.created_at);
                            self.list.push({
                                content: data.data.content,
                                from: data.data.from_userid == self.user_id ? 1 : 2,
                            })
                            //处理管理员回复的消息 data.data.content=内容 data.data.created_at=时间
                        }
                        return;
                    case 2:
                        // image
                        if (data.code == 100) {
                            self.hasNewMessage(data.data.created_at);
                            if(data.data.from_userid != self.user_id){
                                self.list.push({
                                    content: data.data.content,
                                    // from: data.data.from_userid == self.user_id ? 1 : 2,
                                    from: 2,
                                    type: 2,
                                    isLoading: true,
                                    isError: false,
                                    isGet: true,
                                    isShow: self.isShow,
                                    width: data.width,
                                    height: data.height,
                                    _width: data.width <= self.imageMaxWdith ? data.width : self.imageMaxWdith,
                                    _height: data.width <= self.imageMaxWdith ? data.height : data.height * self.imageMaxWdith / data.width,
                                })
                            }
                            //处理管理员回复的消息 data.data.content=内容 data.data.created_at=时间
                        }
                        return;
                }
            };
            this.ws.onclose = function() {
                console.log("WebSocket 已关闭");
                // 停止心跳定时器
                // 断线后自动重连
                // if (isReconnect) {
                    setTimeout(function() {
                        console.log("WebSocket 尝试重新连接");
                        self.wsInit();
                    }, 3 * 1000);
                // }
            };
            // 发生错误回调
            this.ws.onerror = function(e) {
                console.log("WebSocket错误:", e);
            };
        },
        enter(e){
            if (!e.shiftKey && e.keyCode == 13) {
                e.cancelBubble = true; //ie阻止冒泡行为
                e.stopPropagation();//Firefox阻止冒泡行为
                e.preventDefault(); //取消事件的默认动作*换行
                //以下处理发送消息代码
                this.send();
            }
        },
        send(){
            if(this.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                // 未输入
                return false;
            }
            var data = {
                mode: "say",
                from_userid: this.user_id, //管理员默认id
                to_userid: 9999999, //用户自己的ID
                content: this.content, //消息
                from: 1, //默认1 为自己的消息
                from_name: this.user_name, //用户名称
                type: 1, //1: text| 2: image
            };
            this.ws.send(JSON.stringify(data));
            this.content = '';
        },
        // 显示|隐藏emoji
        showEmoji(){
            this.isShowEmoji = !this.isShowEmoji;
        },
        hideEmoji(){
            this.isShowEmoji = false;
        },
        // 选择emoji
        chooseEmoji(emoji){
            this.content += emoji;
        },
        // 获取文件信息
        getFileData(){
            const file = this.$refs.file.files[0];
            // console.log(file)
            const type = file.type;
            this.getFileReader(file, type);
        },
        getFileReader(file, type){
            // let self = this;
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // console.log(reader);
                let _img = new Image();
                _img.src = reader.result;
                _img.onload = () => {
                    let index = this.list.length;
                    // 先在列表上显示
                    this.list.push({
                        content: reader.result,
                        from: 1,
                        type: 2,
                        isLoading: true,
                        isError: false,
                        isGet: false,
                        isShow: true,
                        width: _img.width,
                        height: _img.height,
                        _width: _img.width <= this.imageMaxWdith ? _img.width : this.imageMaxWdith,
                        _height: _img.width <= this.imageMaxWdith ? _img.height : _img.height * this.imageMaxWdith / _img.width,
                    })
                    // 压缩
                    if(file.size > 512*1024){
                        this.suofang(reader.result, 1.5, type, (blob, base64)=>{
                            this.upLoad(blob, index);
                        })
                    }else{
                        this.upLoad(file, index);
                    }
                }
            };
        },
        upLoad(data, index){
            // 上传
            let formData = new FormData();
            formData.append('image', data);
            this.$store.dispatch('upImages', formData).then((result) => {
                this.list[index].content = result.data;
                this.list[index].isLoading = false;
                var data = {
                    mode: "say",
                    from_userid: this.user_id, //管理员默认id
                    to_userid: 9999999, //用户自己的ID
                    content: result.data, //消息
                    from: 1, //默认1 为自己的消息
                    from_name: this.user_name, //用户名称
                    type: 2, //1: text| 2: image
                    width: result.width,
                    height: result.height,
                };
                this.ws.send(JSON.stringify(data));
            }).catch((err) => {
                this.list[index].isError = true;
            });;
        },
        suofang(base64, bili, type, callback) {
            // console.log("执行缩放程序,bili=" + bili);
            //处理缩放，转格式
            let self = this;
            var _img = new Image();
            _img.src = base64;
            _img.onload = function() {
                var _canvas = document.createElement("canvas");
                var w = this.width / bili;
                var h = this.height / bili;
                _canvas.setAttribute("width", w);
                _canvas.setAttribute("height", h);
                _canvas.getContext("2d").drawImage(this, 0, 0, w, h);
                var base64 = _canvas.toDataURL(type);
                _canvas.toBlob(function(blob) {
                    // console.log(blob.size);
                    if(blob.size > 512*1024){
                        self.suofang(base64, bili, type, callback);
                    }else{
                        callback(blob, base64);
                    }
                }, type);
            }
        },
        paste(){
            if(navigator.clipboard && navigator.clipboard.read){
                navigator.clipboard // 创建clipboard对象
                    .read() // 调用readText()方法
                    .then((items) => {
                        // 成功回调 
                        items.forEach( item => {
                            // console.log(item)
                            item.types.forEach( type => {
                                // console.log(type)
                                if(type.indexOf('image/') != -1){
                                    item.getType(type).then((result) => {
                                        // console.log(result);
                                        // blob
                                        // console.log(URL.createObjectURL(result));
                                        this.getFileReader(result, type);
                                    }).catch((err) => {
                                        console.log(err);
                                    });
                                }
                            })
                        })
                    })
                    .catch((err) => console.log("粘贴失败！",err)); // 失败回调
            }else{
                console.log('浏览器不支持粘贴！');
            }
        },
    },
};
</script>

<template>
    <div class="customerService">
        <div class="switch" @click="isShow = true" :class="{new: hasNewMes}">
            <img src="@/assets/images/icon_customer_service.png" alt="" class="icon">
        </div>
        <div class="popup" :class="{active: isShow}">
            <div class="in">
                <div class="top">
                    <div class="title">440ME customer service at your service</div>
                    <div class="btn_close" @click="isShow = false"></div>
                </div>
                <div class="message" ref="messageWrap">
                    <div class="list" ref="message">
                        <div class="item" :class="{mine: item.from == 1}" v-for="(item, index) in list" :key="index">
                            <div class="box" :class="{image: item.type == 2}">
                                <!-- 图片 -->
                                <template v-if="item.type == 2">
                                    <!-- 是获取的，getdata或者是ws客服发过来的 -->
                                    <div class="image" v-if="item.isGet" :style="{width: `${item._width}px`, height: `${item._height}px`}">
                                        <!-- 是否显示 item.isShow -->
                                        <!-- 弹窗显示的时候再显示图片，减少页面打开的加载 -->
                                        <a v-if="item.isShow" :href="item.content" target="_blank">
                                            <img :src="item.content" alt="" @load="item.isLoading = false" @error="item.isError = true"/>
                                        </a>
                                        <!-- 加载图片失败 -->
                                        <div class="error" v-if="item.isError"></div>
                                        <!-- loading -->
                                        <div class="loading" v-else-if="item.isLoading"></div>
                                    </div>
                                    <!-- 自己上传的 -->
                                    <div class="image" v-else :style="{width: `${item._width}px`, height: `${item._height}px`}">
                                        <!-- 自己上传的就不用判定 item.isShow -->
                                        <!-- 自己上传的 item.isLoading 在上传完图片后 isLoading=false -->
                                        <!-- 本地base64无法通过a链接打开，所以需要加 isLoading 判定 -->
                                        <img :src="item.content" alt="" v-if="item.isLoading"/>
                                        <a v-else :href="item.content" target="_blank">
                                            <img :src="item.content" alt=""/>
                                        </a>
                                        <!-- 图片上传失败 -->
                                        <div class="error" v-if="item.isError"></div>
                                        <!-- loading -->
                                        <div class="loading" v-else-if="item.isLoading"></div>
                                    </div>
                                </template>
                                <!-- 文本 -->
                                <div class="text" v-else>{{toReg(item.content)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="btn_group">
                        <!-- emoji -->
                        <div class="item">
                            <img src="@/assets/images/icon_emoji.png" alt="" class="icon" @click.stop="showEmoji">
                            <div class="emoji_wrap" v-if="isShowEmoji">
                                <div class="emoji_group">
                                    <div class="emoji" v-for="(item, index) in emoji" :key="index" @click.stop="chooseEmoji(item)">{{item}}</div>
                                </div>
                            </div>
                        </div>
                        <!-- file -->
                        <div class="item" @click="$refs.file.click()">
                            <img src="@/assets/images/icon_up_image.png" alt="" class="icon">
                            <input type="file" style="display: none;" accept="image/*" capture="camera" ref="file" @change="getFileData" />
                        </div>
                        <!-- 提示 -->
                        <div class="item">Press Enter to send the message</div>
                    </div>
                    <!-- pc -->
                    <div class="content_wrap pc">
                        <textarea class="content" v-model="content" @keydown="enter" @paste="paste"/>
                    </div>
                    <!-- mobile -->
                    <div class="content_wrap mobile">
                        <textarea class="content" v-model="content"/>
                        <!-- <div class="content_text">
                            <div class="content_val">{{content}}</div>
                            <textarea class="content" v-model="content"/>
                        </div> -->
                        <div class="btn" @click="send">send</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.customerService{
    .switch{
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background: #e8e8e6;
        z-index: 1;
        cursor: pointer;
        &.new{
            &::after{
                content: '';
                display: block;
                position: absolute;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: red;
                top: 0;
                right: 0;
                animation: new 1s infinite alternate both;
            }
            @keyframes new {
                0%{
                    opacity: 0;
                }
                100%{
                    opacity: 1;
                }
            }
        }
        @media screen and (max-width: 768px) {
            width: 1rem;
            height: 1rem;
            bottom: 2rem;
            right: .4rem;
            &.new{
                &::after{
                    width: .1rem;
                    height: .1rem;
                }
            }
        }
    }
    .popup{
        position: fixed;
        top: 0;
        left: 0;
        background: rgba($color: #000000, $alpha: .5);
        width: 100%;
        height: 100%;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 110px;
        opacity: 0;
        visibility: hidden;
        transition: opacity .3s, visibility .3s;
        &.active{
            opacity: 1;
            visibility: visible;
        }
        @media screen and (max-width: 768px) {
            padding-top: 1.2rem;
        }
        .in{
            width: 828px;
            background: #fff;
            @media screen and (max-width: 768px) {
                width: 100%;
                height: 100%;
                border-radius: 0;
                display: flex;
                flex-direction: column;
            }
            .bottom{
                // border: 1px solid #eaeaea;
                // border-top: none;
                // margin: 15px;
                // margin-top: 0;
                .btn_group{
                    display: flex;
                    align-items: center;
                    padding: 8px 10px;
                    .item{
                        margin-right: 15px;
                        cursor: pointer;
                        font-size: 14px;
                        color: #868686;
                        line-height: 1;
                        position: relative;
                        .icon{
                            width: 18px;
                            height: 18px;
                        }
                        .emoji_wrap{
                            position: absolute;
                            left: 50%;
                            bottom: calc(100% + 20px);
                            transform: translate(-50%, 0);
                            background: #fff;
                            overflow: hidden;
                            overflow-y: auto;
                            height: 260px;
                            box-shadow: 0 0 4px 4px rgba($color: #000000, $alpha: .2);
                            .emoji_group{
                                font-size: 20px;
                                width: 260px;
                                display: flex;
                                flex-wrap: wrap;
                                padding: 10px;
                                user-select: none;
                                .emoji{
                                    width: 30px;
                                    height: 30px;
                                    text-align: center;
                                    line-height: 30px;
                                }
                            }
                        }
                    }
                }
                @media screen and (max-width: 768px) {
                    .btn_group{
                        padding: .2rem .3rem;
                        .item{
                            margin-right: .3rem;
                            font-size: .24rem;
                            .icon{
                                width: .36rem;
                                height: .36rem;
                            }
                            .emoji_wrap{
                                left: -0.3rem;
                                bottom: calc(100% + .2rem);
                                transform: none;
                                height: 5rem;
                                box-shadow: 0 0 2px 2px rgba($color: #000000, $alpha: .2);
                                .emoji_group{
                                    width: 7.5rem;
                                    font-size: .48rem;
                                    padding: .15rem;
                                    .emoji{
                                        width: .9rem;
                                        height: .9rem;
                                        line-height: .9rem;
                                    }
                                }
                            }
                        }
                    }
                }
                .content_wrap{
                    display: flex;
                    padding-bottom: 10px;
                    .content{
                        appearance: none;
                        border: none;
                        border-radius: 0;
                        background: none;
                        resize: none;
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                        outline: none;
                        flex: 1;
                        height: 90px;
                        padding: 0 10px;
                        font-family: 'bpg_glaho';
                        font-size: 14px;
                    }
                    &.mobile{
                        display: none;
                    }
                    .btn{
                        cursor: pointer;
                        display: none;
                    }
                    @media screen and (max-width: 768px) {
                        padding-bottom: 0;
                        &.pc{
                            display: none;
                        }
                        &.mobile{
                            display: flex;
                        }
                        .content_text{
                            flex: 1;
                            position: relative;
                            .content{
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                top: 0;
                            }
                        }
                        .content_val{
                            max-height: 2rem;
                            white-space: pre-wrap;
                            word-break: break-all;
                            word-wrap: break-word;
                        }
                        .content_val,
                        .content{
                            font-size: .28rem;
                            background: #fff;
                            border-radius: .1rem 0 0 .1rem;
                            // min-height: .7rem;
                            height: 2rem;
                            // padding: .14rem .2rem;
                            padding: 0 .2rem;
                            line-height: 1.5;
                        }
                        .btn{
                            display: block;
                            background: #000;
                            color: #fff;
                            font-size: .28rem;
                            padding: 0 .2rem;
                            // line-height: .7rem;
                            display: flex;
                            align-items: center;
                        }
                    }
                }
            }
            .message{
                height: 465px;
                border-bottom: 1px solid #8c8c8c;
                overflow: hidden;
                overflow-y: auto;
                @media screen and (max-width: 768px) {
                    height: auto;
                    flex: 1;
                    border-bottom: 1px solid #c6c6c6;
                }
                .list{
                    display: flex;
                    flex-direction: column;
                    .item{
                        display: flex;
                        margin-top: 20px;
                        padding: 0 20px;
                        &:last-child{
                            margin-bottom: 20px;
                        }
                        @media screen and (max-width: 768px) {
                            margin-top: .4rem;
                            padding: 0 .4rem;
                            &:last-child{
                                margin-bottom: .4rem;
                            }
                        }
                        &.mine{
                            justify-content: flex-end;
                            .box{
                                background: #c0c0c0;
                                &::after{
                                    left: auto;
                                    right: -7px;
                                    border-right: none;
                                    border-left: 8px solid #c0c0c0;
                                }
                            }
                        }
                        .box{
                            max-width: 80%;
                            // height: 46px;
                            border-radius: 10px;
                            background: #dadada;
                            color: #fff;
                            font-size: 14px;
                            line-height: 1.5;
                            padding: 10px 20px;
                            position: relative;
                            &.image{
                                max-width: 220px;
                                padding: 10px;
                            }
                            &::after{
                                content: "";
                                border-right: 8px solid #dadada;
                                border-top: 6px solid transparent;
                                border-bottom: 6px solid transparent;
                                position: absolute;
                                top: 14px;
                                left: -7px;
                            }
                            @media screen and (max-width: 768px) {
                                border-radius: .1rem;
                                font-size: .24rem;
                                padding: .2rem .4rem;
                                &.image{
                                    max-width: 4rem;
                                    padding: .2rem;
                                }
                                &::after{
                                    border-right: .16rem solid #dadada;
                                    border-top: .12rem solid transparent;
                                    border-bottom: .12rem solid transparent;
                                    top: .26rem;
                                    left: -0.14rem;
                                }
                            }
                            .text{
                                white-space: pre-wrap;
                                word-break: break-all;
                                word-wrap: break-word;
                                /deep/{
                                    a{
                                        color: #857cb8;
                                    }
                                }
                            }
                            .image{
                                position: relative;
                                .error,
                                .loading{
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    background: rgba($color: #000000, $alpha: .5);
                                    pointer-events: none;
                                }
                                .loading{
                                    &::after{
                                        content: '';
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin: -15px 0 0 -15px;
                                        width: 30px;
                                        height: 30px;
                                        border: 2px solid #fff;
                                        border-top-color: transparent;
                                        border-radius: 100%;
                                        animation: circle infinite 0.75s linear;
                                    }
                                    // 转转转动画
                                    @keyframes circle {
                                        0% {
                                            transform: rotate(0);
                                        }
                                        100% {
                                            transform: rotate(360deg);
                                        }
                                    }
                                }
                                .error{
                                    &::after{
                                        content: '!';
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin: -15px 0 0 -15px;
                                        width: 30px;
                                        height: 30px;
                                        border: 2px solid #fff;
                                        border-radius: 100%;
                                        font-size: 24px;
                                        text-align: center;
                                        line-height: 34px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 56px;
                border-bottom: 1px solid #8c8c8c;
                font-size: 14px;
                color: #868686;
                padding: 0 15px;
                .btn_close{
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    position: relative;
                    &::before,
                    &::after{
                        content: "";
                        display: block;
                        width: 20px;
                        height: 1px;
                        background: #8c8c8c;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%) rotate(45deg);
                    }
                    &::after{
                        transform: translate(-50%, -50%) rotate(-45deg);
                    }
                }
                @media screen and (max-width: 768px) {
                    height: 1.14rem;
                    font-size: .28rem;
                    padding: 0 .3rem;
                    border-top: 1px solid #c6c6c6;
                    border-bottom: 1px solid #c6c6c6;
                    .btn_close{
                        width: .5rem;
                        height: .5rem;
                        &::before,
                        &::after{
                            width: .4rem;
                            height: .02rem;
                        }
                    }
                }
            }
        }
    }
}
</style>